import { useInView } from "react-intersection-observer";
import { useNavigate } from "react-router-dom";
import styled, { css, keyframes } from "styled-components";
import WomenCategoryImg from "../../../assets/images/image/cashmere.webp";
import MenCategoryImg from "../../../assets/images/image/coats-and-jackets.webp";
import ScarvesCategoryImg from "../../../assets/images/image/scarves.webp";
import CategoryCard from "../../cards/CategoryCard";

const fadeUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Wrapper = styled.div``;

const Container = styled.div`
  display: grid;
  gap: 16px;
  margin: 24px 40px;
  grid-template-columns: repeat(3, minmax(0, 1fr));

  @media (max-width: 1200px) {
    margin: 24px 20px;
    grid-template-columns: repeat(2, minmax(0, 1fr));

    & > *:nth-child(3) {
      grid-column: 1 / -1;
    }
  }

  @media (max-width: 650px) {
    grid-template-columns: 1fr;
  }
`;

const AnimatedItem = styled.div`
  opacity: 0;
  transform: translateY(20px);

  ${({ inView, delay }) =>
    inView &&
    css`
      animation: ${fadeUp} 1s ease forwards;
      animation-delay: ${delay}s;
    `}
`;

function CategorySection() {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });
  const navigate = useNavigate();

  return (
    <Wrapper ref={ref}>
      <Container>
        <AnimatedItem inView={inView} delay={0}>
          <CategoryCard
            category="Coats & Jackets"
            img={MenCategoryImg}
            onClick={() => {
              navigate("/browse?category=coatAndJackets");
            }}
          />
        </AnimatedItem>

        <AnimatedItem inView={inView} delay={0.15}>
          <CategoryCard
            category="Cashmere"
            img={WomenCategoryImg}
            onClick={() => {
              navigate("/browse?category=cashmere");
            }}
          />
        </AnimatedItem>

        <AnimatedItem inView={inView} delay={0.3}>
          <CategoryCard
            category="Scarves"
            img={ScarvesCategoryImg}
            onClick={() => {
              navigate("/browse?category=accessories");
            }}
          />
        </AnimatedItem>
      </Container>
    </Wrapper>
  );
}

export default CategorySection;
